module.exports = __webpack_public_path__ + "static/media/Zelt.5e6a2dc7.png";